function PredictiveSearch(params) {
    if(!params.element.length) {
        return;
    }
    
    this.setDefaults(params);
    this.addListeners();
}

PredictiveSearch.prototype.setDefaults = function(params) {
    this.api = {
        predictive: "/api/WorkforcePartnerships/PredictiveSearch"
    };
        
    this.dom = {
        $el: params.element,
        $field: params.element.find(params.field),
        $predictiveSearchResults: params.element.find(params.predictiveSearchResults)
    };
    this.dom.$predictiveSearchResults.attr('aria-expanded', false);

    this.keycodes = {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        UP: 38,
        DOWN: 40
    };
};

PredictiveSearch.prototype.addListeners = function() {
    $(document).on('click', this.onClickOutside.bind(this));
    this.dom.$el.on("submit", this.handleClear.bind(this));
    this.dom.$field.on("keyup", this.handleSearch.bind(this));
    this.dom.$field.on("keydown", this.handleNavigation.bind(this));
};

PredictiveSearch.prototype.open = function(html) {
    this.dom.$field.attr('aria-expanded', true);
    this.dom.$predictiveSearchResults.html(html).attr('aria-expanded', true).show();
}

PredictiveSearch.prototype.close = function() {
    this.dom.$field.attr('aria-expanded', false);
    this.dom.$predictiveSearchResults.html('').attr('aria-expanded', false).hide();
}

PredictiveSearch.prototype.onClickOutside = function (e) {
    if (!this.dom.$field.is(e.target)
        && this.dom.$field.has(e.target).length === 0
        && !this.dom.$predictiveSearchResults.is(e.target)
        && this.dom.$predictiveSearchResults.has(e.target).length === 0) {
        this.close();
    }
}

PredictiveSearch.prototype.handleClear = function(e) {
     this.close();
}

PredictiveSearch.prototype.handleSearch = function (e) {
    var _this = this;
    var kc = e.keyCode;

    if (kc === this.keycodes.UP || kc === this.keycodes.DOWN) {
        return;
    }

    if (e.keyCode === this.keycodes.ESCAPE || e.keyCode === this.keycodes.ENTER) {
        this.close();
        return;
    }

    var keyword = this.dom.$field.val();
    
    if (keyword) {
        $.getJSON('/api/WorkforcePartnerships/PredictiveSearch?keyword=' + keyword, function(data) {
            if (data.length) {
                var options = '';

                data.forEach(function(option) {
                    options += '<li role="option"><a href="'+option.Url+'" tabindex="-1">'+option.Headline+'</a></li>'
                });
                
                _this.open(options);

            } else {
                _this.close();
            }
        });
    } else {
        _this.close();
    }
}

PredictiveSearch.prototype.handleNavigation = function (e) {
    var kc = e.keyCode;

    if(e.keyCode === this.keycodes.ENTER) {
        var $activeItem = this.dom.$predictiveSearchResults.find('[aria-selected="true"]');

        if($activeItem.length) {
            $activeItem[0].click();
            return;
        }
    }

    if (kc === this.keycodes.TAB) {
        this.close();
    }
    if (kc === this.keycodes.UP || kc === this.keycodes.DOWN) {
        e.preventDefault();
        this.arrowing(kc);
    }
}

PredictiveSearch.prototype.arrowing = function (kc) {
    var $thisActiveItem = this.dom.$predictiveSearchResults.find('[aria-selected="true"]').parent(),
        $nextMenuItem;

    // don't do anything if no results
    if (!this.dom.$predictiveSearchResults.children().length) {
        return;
    }
    if (kc === this.keycodes.DOWN) {
        // find the next list item to be arrowed to
        $nextMenuItem = ($thisActiveItem.length !== 0)
            ? $thisActiveItem.next('li')
            : this.dom.$predictiveSearchResults.children().eq(0); //first item in list
    }
    if (kc === this.keycodes.UP) {
        // find the previous list to be arrowed to
        $nextMenuItem = ($thisActiveItem.length !== 0)
            ? $thisActiveItem.prev('li')
            : this.dom.$predictiveSearchResults.children().eq(-1); //last item in list
    }
    this.markSelected($nextMenuItem);
}

PredictiveSearch.prototype.clearSelected = function () {
    this.dom.$predictiveSearchResults.find('[aria-selected="true"]').attr('aria-selected', 'false');
}

PredictiveSearch.prototype.markSelected = function (selectionToMark) {
    this.clearSelected();
    // don't mark anything on the results list if we're back at the input field
    if (selectionToMark.length === 0) return;
    selectionToMark.find('a').attr('aria-selected', 'true');
}

$('.wp-explore-more').each(function(i, el) {
    new PredictiveSearch({
        element: $(el),
        field: ".wp-explore-more__search-field",
        predictiveSearchResults: ".wp-explore-more__search-predictive-results"
    });
});